import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-email-preview-dialog',
  templateUrl: './email-preview-dialog.component.html',
  styleUrls: ['./email-preview-dialog.component.scss']
})
export class EmailPreviewDialogComponent {
  subjectForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EmailPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { subject: string; content: string },
    private fb: FormBuilder
  ) {
    this.subjectForm = this.fb.group({
      subject: [data.subject || '']
    });
  }

  onClose(): void {
    this.dialogRef.close({
      subject: this.subjectForm.value.subject,
      content: this.data.content
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}